export const socialsData = {
    github: 'https://github.com/kanav1999',
    facebook: 'https://www.linkedin.com/in/kanav-sharma-6258901a8/',
    linkedIn: 'https://www.linkedin.com/in/kanav-sharma-6258901a8/',
    twitter: 'https://github.com/kanav1999',
    mail: 'kanav0099@gmail.com',
}